import { useAdminAuth } from "../contexts/AdminAuthContext";
import { AdminApi } from "../lib/adminApi";

/** Admin API クライアント (typed) を Context から取得する薄いフック */
export const useAdminApi = (): AdminApi => {
  const { api } = useAdminAuth();
  return api;
};

/** 生の Axios インスタンスが欲しい場合はこちらを使う */
export const useAdminAxios = () => {
  const { apiClient } = useAdminAuth();
  return apiClient;
};

export default useAdminApi;
